import { createContext } from 'react';

export const DataElementContext = createContext<any | null>(null);
